import React from 'react';
import { TicketHeaderPanel } from '../components/ticket-header-panel';
import { TicketLane } from '../components/ticket-lane';
import styled from 'styled-components';
import { Queue } from '../../../types/queue';
import { BoothTicket } from '../../../types/ticket';
import { sizes } from '../../../themes/sizes';
import { breakpoints } from '@nextinq/ui-toolkit';

const Container = styled.section`
  min-width: 320px;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  padding: ${sizes.margins.large} ${sizes.margins.massive};
  display: grid;
  grid-template-rows: auto 1fr;
  gap: ${sizes.margins.large};
  @media ${breakpoints.max.smallPhone} {
    padding: 0;
  }
`;
const Header = styled.header``;
const Lanes = styled.section`
  height: 100%;
  overflow-y: hidden;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 18px;
`;

export interface QueueListProps {
  queues: Array<Queue>;
  currentTicket: BoothTicket | null;
  previousTickets: Array<BoothTicket>;
  onAppendTicket: (queueId: string, ticketNote: string) => void;
}

export function QueueList(props: QueueListProps) {
  const { currentTicket, previousTickets, onAppendTicket } = props;
  return (
    <Container>
      <Header>
        <TicketHeaderPanel
          currentTicket={currentTicket}
          previousTickets={previousTickets}
        />
      </Header>
      <Lanes>
        {props.queues.map((q) => (
          <TicketLane
            queue={q}
            key={q.id}
            onAppendTicket={(ticketNote) => onAppendTicket(q.id, ticketNote)}
          />
        ))}
      </Lanes>
    </Container>
  );
}
